import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ClientProductTypes } from "../../common/interfaces/enums/ProductType";
import { QuoteGroupContext } from "../providers/RootContextProvider";

interface IProductPageContainerProps {
    productType?: ClientProductTypes;
    hasSettingsRedirect?: boolean;
    hasFamilyRedirect?: boolean;
}

const ProductPageContainer: React.FC<IProductPageContainerProps> = ({
    productType,
    hasSettingsRedirect,
    hasFamilyRedirect,
    children
}) => {
    const { selectors } = useContext(QuoteGroupContext);
    const isNewSession = selectors.isNewSession();
    const groupId = selectors.getGroupId();
    const hasCreatedQuote = selectors.hasCreatedQuote();
    const isLoadingQuotes = selectors.isLoadingQuoteResult();

    const history = useHistory();

    useEffect(() => {
        if (!groupId) return;

        if (hasFamilyRedirect && isNewSession) {
            if (productType) {
                history.replace(`/family?product=${productType}`);
            } else {
                history.replace(`/family`);
            }
        } else if (
            productType &&
            hasSettingsRedirect &&
            !hasCreatedQuote &&
            !isLoadingQuotes
        ) {
            history.replace(`/${productType}/settings`);
        }
    }, [groupId]);

    return <React.Fragment>{children}</React.Fragment>;
};

export default ProductPageContainer;
